import * as React from "react";

import { theme, dotaSpottoTheme } from "@ds-components/General/dotaspottotheme";
import { useAuthStore } from "@/store/authStore";

// <=== 💸  MUI Stuff  💸 ===>
import { ThemeProvider } from "@mui/material/styles";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
// import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";
import Menu from '@mui/material/Menu';
import { Button, Link, MenuItem } from "@mui/material";

// import { getLocalStorage, setLocalStorage } from "@ds-services/helpers";
// import { SpotifyApi } from "@spotify/web-api-ts-sdk";

const SpotifyLogin: React.FC<{}> = () => {
	// <=== 💸  START States  💸 ===>
	const { status, userProfile, logout } = useAuthStore();
	const [spotifyChipPopover, setSpotifyChipPopover] = React.useState<HTMLElement | null>(null);

	const spotifyChipOpen = (event: React.MouseEvent<HTMLElement>) => {
		setSpotifyChipPopover(event.currentTarget);
	};
	const spotifyChipClose = () => {
		setSpotifyChipPopover(null);
	};
	const openPopover = Boolean(spotifyChipPopover);
	// <=== 💸  END States  💸 ===>
	return (
		<AppBar
			position="static"
			enableColorOnDark
			sx={{
				boxShadow: 0,
				bgcolor: 'transparent',
				backgroundImage: 'none',
				// mt: 'calc(var(--template-frame-height, 0px) + 28px)',
			}}
		>
			<Container sx={{
				padding: 1
			}}>
				<ThemeProvider theme={theme}>
					{(status === "authenticated") && !window.location.search.includes("error=access_denied") && userProfile && (
						<>
							<Box id="spotify-user-profile">
								<Stack direction="row" spacing={1} sx={{
									display: "flex",
									alignItems: "center",
									justifyContent: "flex-end",
									gap: 2,
								}}
								>
									<Chip
										avatar={
											<Avatar
												// sizes="small"
												alt={`${userProfile.display_name} Portrait`}
												src={userProfile.images.length > 0 ? userProfile.images[0].url : ''}
											/>
										}
										component="a"
										target="_blank"
										color="primary"
										label={userProfile.display_name}
										sx={{
											// height: 70,
											"& .MuiChip-label": {
												fontSize: "1.25rem",
												paddingRight: 2,
											},
										}}
										onClick={spotifyChipOpen}
										clickable
									/>
									<Menu
										id="spotify-profile-menu"
										open={openPopover}
										anchorEl={spotifyChipPopover}
										transformOrigin={{ horizontal: 'right', vertical: 'top' }}
										anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
										onClose={spotifyChipClose}
										onClick={spotifyChipClose}
										sx={{
											"& .MuiMenu-list": {
												display: "flex",
												flexFlow: "column nowrap",
												gap: 1
											},
											"& .MuiMenuItem-root": {
												margin: "0 10px",
												borderRadius: "5px",
												transition: "all 0.35s ease",
												"& .MuiButton-root": {
													color: dotaSpottoTheme.primary,
													// fontWeight: "bold"
												},
												"&:hover": {
													backgroundColor: "gold",
													"& .MuiButton-root": {
														color: dotaSpottoTheme.primary,
													},
												}
											}
										}}
									>
										<MenuItem onClick={spotifyChipClose}>
											<Button
												href={userProfile.external_urls.spotify}
												target="_blank"
											>View Profile</Button>
										</MenuItem>
										<MenuItem onClick={spotifyChipClose}>
											<Button
												sx={{
												}}
												onClick={() => {
													logout(), spotifyChipClose()
												}}>
												Log Out
											</Button>
										</MenuItem>
									</Menu>
								</Stack>
							</Box>
						</>
					)}
				</ThemeProvider>
			</Container>
		</AppBar>
	);
};

export default SpotifyLogin;
